<template>
  <div class="box3">
    <pageTitle
      title="AI时代&nbsp;&nbsp;未来已来"
      text="国家战略引领与政策支持下，AI行业正面临重要的<br />发展“薪”机遇"
    />

    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <div class="img-box" @click="previewImage(item)">
              <p>点击查看大图</p>
              <img :class="'img' + index" :src="item.url" alt />
            </div>
            <div class="title">{{ item.title }}</div>
            <div class="text" v-html="item.text"></div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- <div class="swiper-pagination-box3"></div> -->
    </div>

    <div class="previewImage" v-if="isPreview" @click="close">
      <img :src="imageUrl" alt />
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},
  data() {
    // let that = this;
    return {
      cur: 0,
      swiperOption: {
        // loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 16,
        // slidesOffsetBefore: 16,
        // slidesOffsetAfter: 16,
        pagination: {
          el: ".swiper-pagination-box3",
        },
        // on: {
        //   click: function(event) {
        //     that.cur = this.realIndex;
        //     if (event.target.nodeName === "IMG") {
        //       that.previewImage();
        //     }
        //   }
        // }
      },
      list: [
        {
          title: "国家战略助发展",
          text: "早在2017年，人工智能就已上升国家战略层面。<br />《新一代人工智能发展规划》制定了2030年人<br />工智能战略目标。",
          url: require("../../../assets/coursePage/ai/box3/1.png"),
        },
        {
          title: "IT行业薪资天花板",
          text: "根据《2022年春招市场行情周报》显示，人工智<br />能岗位招聘薪资位于二十大高薪职业排行第二，仅<br />次于高管，远超其它开发岗位。",
          url: require("../../../assets/coursePage/ai/box3/2.png"),
        },
      ],
      isPreview: false,
      imageUrl: "",
    };
  },
  methods: {
    close() {
      this.isPreview = false;
      this.imageUrl = "";
    },
    previewImage(item) {
      this.imageUrl = item.url;
      this.isPreview = true;
    },
  },
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box3/box3-bg.png") no-repeat;
  background-size: cover;
  overflow: hidden;

  .previewImage {
    position: fixed;
    top: 0px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 200;
    img {
      width: 100%;
    }
  }

  .subject-content {
    position: relative;
    margin-top: 70px;
    padding: 0 32px;
    box-sizing: border-box;

    /deep/.swiper-container {
      overflow: unset;
    }

    .block {
      position: relative;
      padding: 40px 0 0 40px;
      width: 100%;
      height: 100%;
      box-sizing: border-box;

      .img-box {
        position: absolute;
        right: 28px;
        top: -20px;
        width: 200px;
        height: 128px;
        border: 4px solid #fff;
        box-shadow: 0px 24px 60px 0px rgba(94, 123, 218, 0.1),
          0px 12px 24px -16px rgba(94, 123, 218, 0.16);
        border-radius: 20px;
        overflow: hidden;

        p {
          position: absolute;
          bottom: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 152px;
          height: 40px;
          background: rgba(27, 27, 27, 0.7);
          border-radius: 0px 24px 0px 0px;

          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }

        img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }

        .img1 {
          width: 100%;
          height: 250%;
        }
      }

      .title {
        margin-bottom: 32px;
        font-size: 28px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 44px;
      }

      .text {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #1d2129;
        line-height: 44px;
      }
    }
  }

  .swiper-slide {
    width: 616px;
    height: 292px;
    background: linear-gradient(
      216deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(250, 253, 254, 0.46) 31%,
      #d4f8ff 100%
    );
    border-radius: 20px;
    border: 4px solid #8bdefe;
    box-sizing: border-box;
  }

  .swiper-pagination-box3 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #d7effe;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
}
</style>
